import {Alert, Anchor} from '@mantine/core';
import React from 'react';

import {CREDIT_TIERS, type EmailType, MODEL_HUB_MARKETING_URL} from './constants';

interface UpsellCalloutProps {
  emailType: EmailType;
  onUseWorkEmail: () => void;
}

/** Shows personal and academic users how to access more free predictions. */
export default function UpsellCallout({emailType, onUseWorkEmail}: UpsellCalloutProps): JSX.Element {
  const workPredictions = CREDIT_TIERS.work.predictionsPerMonth.toLocaleString();

  return (
    <Alert
      color="yellow"
      title={
        emailType === 'edu'
          ? 'Get more free predictions through a verified academic institution on benchling.com'
          : 'Get more with a work email'
      }
    >
      {emailType === 'edu' ? (
        <>
          Academic users with verified institution emails can explore more at{' '}
          <Anchor href={MODEL_HUB_MARKETING_URL} rel="noopener noreferrer" target="_blank">
            benchling.com/model-hub
          </Anchor>
          .
        </>
      ) : (
        <>
          A verified life science industry email unlocks {workPredictions} predictions per month.{' '}
          <Anchor component="button" type="button" onClick={onUseWorkEmail}>
            Use a different email
          </Anchor>
          .
        </>
      )}
    </Alert>
  );
}
